import { useMutation } from '@tanstack/react-query';
import { getAuthModule } from '../install';
export function useFetchSignInMethods() {
    return useMutation({
        mutationFn: (input) => getAuthModule().actions.fetchSignInMethods(input),
    });
}
